define((require) => {
    "use strict";

    const _                = require("underscore");
    const ExperienceModel  = require("shared/ui/experience/ExperienceModel");
    const Breakpoint       = require("shared/ui/breakpoint/Breakpoint");
    const Locale           = require("shared/services/localization/Locale");
    const LocaleCollection = require("shared/services/localization/LocaleCollection");
    const Preconditions    = require("shared/util/Preconditions");

    const ValueType = {
        BREAKPOINT: "Breakpoint",
        LOCALE: "Localization"
    };

    const AssetReferenceType = {
        EXPERIENCE: "Experience"
    };

    const valueTypes = new Map();
    const assetReferenceTypes = new Map();
    const valueFactories = new Map();

    valueTypes.set(Breakpoint, ValueType.BREAKPOINT);
    valueTypes.set(Locale, ValueType.LOCALE);
    assetReferenceTypes.set(ExperienceModel, AssetReferenceType.EXPERIENCE);

    /**
     * Breakpoint factory
     */
    valueFactories.set(ValueType.BREAKPOINT, (value) => {
        if (value instanceof Breakpoint) {
            return value;
        }

        let threshold;

        if (value.hasOwnProperty("threshold")) {
            threshold = value.threshold;
        } else {
            threshold = value.attributes.threshold;
        }

        Preconditions.isNumber(threshold);

        return new Breakpoint({threshold});
    });

    valueFactories.set(ValueType.LOCALE, (value) => {
        if (value instanceof Locale) {
            return value;
        }

        if (!_.isString(value)) {
            value = value.attributes.value;
        }

        return LocaleCollection.findByLocaleString(value);
    });

    /**
     * Isolates any type knowledge related to group data, in a single module.
     *
     * @module GroupsDescriptor
     */
    return {
        /**
         * Enum representation of the supported asset types, e.g. <tt>ValueType.BREAKPOINT</tt>.
         *
         * @type {Object}
         */
        ValueType,

        /**
         * Enum representation of the supported reference types, e.g. <tt>AssetReferenceType.EXPERIENCE</tt>.
         *
         * @type {Object}
         */
        AssetReferenceType,

        /**
         * Group value types - mapped constructor to type.
         *
         * @type {Map.<Function, String>}
         */
        valueTypes,

        /**
         * Group asset reference types - mapped constructor to type.
         *
         * @type {Map.<Function, String>}
         */
        assetReferenceTypes,

        /**
         * Map of factory functions for creating concrete values.
         *
         * @type {Map.<Function, Function>}
         */
        valueFactories
    };
});



// WEBPACK FOOTER //
// ./src/shared/data/groups/GroupsDescriptor.js